import { useMemo } from 'react'
import { type PageLayoutStore } from 'shared/layout'
import type { IResponseFullCampaign } from 'entities/Campaign'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { CampaignDetailContext } from './context/context'
import { CampaignDetailStore } from './store/CampaignDetailStore'
import { CampaignDetailUi } from './ui/CampaignDetailUi'

type ICampaignDetailProps = {
  response: IResponseFullCampaign
  pageLayoutStore: PageLayoutStore
  entities: IEntitiesStore
}
export const CampaignDetail = ({ response, pageLayoutStore, entities }: ICampaignDetailProps) => {
  const store = useMemo(() => new CampaignDetailStore(response, pageLayoutStore, entities), [])
  return (
    <CampaignDetailContext.Provider value={store}>
      <CampaignDetailUi />
    </CampaignDetailContext.Provider>
  )
}
